import React from 'react';

export default function StatsFooter({ publicStats }) {
  return (
    <footer
      className="mt-12 border-t border-zinc-900 bg-[#050505] text-center py-6 px-4"
      data-testid="dashboard-stats-footer"
    >
      <div className="max-w-4xl mx-auto flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs sm:text-sm">
        <span className="inline-flex items-center gap-2 text-zinc-400">
          <span className="h-2 w-2 rounded-full bg-[#00D26A] animate-pulse"></span>
          Live library
        </span>
        <span className="text-zinc-300">
          <span className="text-[#FFD700] font-semibold" data-testid="footer-stat-barcodes">
            {publicStats?.validated_barcodes ?? 63}
          </span>{' '}
          validated barcodes
        </span>
        <span className="text-zinc-600">·</span>
        <span className="text-zinc-300">
          <span className="text-[#00D26A] font-semibold" data-testid="footer-stat-roi">
            {publicStats?.roi_pct ?? 447}%
          </span>{' '}
          proven ROI
        </span>
        <span className="text-zinc-600">·</span>
        <span className="text-zinc-300">
          <span className="text-[#FFD700] font-semibold" data-testid="footer-stat-lift">
            +{publicStats?.portfolio_lift_pct ?? 107}%
          </span>{' '}
          vs single-buyer
        </span>
      </div>
      {publicStats?.last_updated && (
        <div className="mt-2 text-[11px] text-zinc-600">
          Updated {new Date(publicStats.last_updated).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
        </div>
      )}
    </footer>
  );
}
